import React from 'react'
import { renderSelectField } from './fields'
import { required } from './validators'
import { Field } from 'redux-form'
import {get} from "lodash";

const StateRoomOptions = props => {
  const renderStateRoomLabel = (option, stateRoomData) => {
    const name = get(stateRoomData, 'name', '') || get(option, 'stateroom.name', '')
    return `${name} ${option.stateroomCategoryCode} ${
      option.isRefundable ? '' : ' - Non-Refundable Deposit - '
    }`
  }

  const renderOptions = () => {
    const stateRooms = [
      {
        value: '',
        label: 'Choose A Stateroom'
      }
    ]
    props.stateRoomOptions.forEach(option => {
      const stateRoomData = option.isSuperCategory
        ? option.superCategoryData
        : option.stateroom
      stateRooms.push({
        value: JSON.stringify({
          fareCode: option.selectedFareCode,
          categoryCode: option.stateroomCategoryCode,
          sateRoomName: stateRoomData.name
        }),
        label: renderStateRoomLabel(option, stateRoomData)
      })
    })
    return stateRooms
  }
  return (
    <div className="equote-package-additional-details-form--stateRoomOptions">
      <div className="equote-package-additional-details-form--input-group">
        <label className="equote-package-additional-details-form--input-group--label">
          STATEROOM <br />
          PREFERENCES
          <br />
          <span style={{ color: 'red' }}>*</span>
        </label>
      </div>
      <Field
        component={renderSelectField}
        name="Choose A Stateroom"
        options={renderOptions()}
        validate={required}
      />
    </div>
  )
}

export default StateRoomOptions
